export const TARGET_RATES_APP_STATE_SLICE_KEY = 'targetRates';
export const TARGET_RATES_DEFAULT_STATE = {
    showRecessions: false,
};
